import React from "react";
import { Link } from "react-scroll";
import { Parallax } from "react-parallax";
import Typewriter from "typewriter-effect";
import { scrollDuration } from "../../../config/commonConfig";
import "../../../sass/IntroImageBg.scss";

const FullScreenImgBgIntro = () => {
  return (
    <section id="home">
      <div className="hero-wrap">
        <div className="hero-mask opacity-5 bg-light" />
        <Parallax
          bgImage="images/images/HMS (1).jpg"
          bgImageAlt="Intro"
          strength={200}
        >
          <div className="hero-content text-left d-flex fullscreen py-5">
            <div className="container my-auto py-4">
              <div className="row">
                <div className="col-lg-7 text-primary order-1 order-lg-0" >
                  <h1 className="text-18 text-left text-crimson fw-600 mb-0 text-uppercase">
                    Boston <br/>
                    Structural <br/>
                    Heart<br/>   
                  </h1>
                  <h2 className="text-13 text-color fw-400 text-uppercase mb-0 ms-n1"  >
                    <Typewriter
                      options={{
                        strings: ["11 - 13 AUG 2023"],
                        autoStart: true,
                        loop: true,
                      }}
                    />{" "}
                  </h2>
                  <p className="text-5 text-white mb-0 ms-n1" >
                    A virtual "live" CME event covering all key concepts in structural heart disease imaging and beyond, from basics to advance levels including 3D TEE.
                  </p>
                  <Link
                    className="btn btn-primary fw-600 rounded-0 smooth-scroll mt-3"
                    smooth="easeInOutQuint"
                    duration={scrollDuration}
                    style={{ cursor: "pointer", color: "white" }}
                    to="portfolio"
                    
                  >
                    Register Here
                  </Link>
                </div>
              </div>
            </div>
            <Link
              className="scroll-down-arrow text-light smooth-scroll"
              smooth="easeInOutQuint"
              duration={scrollDuration}
              style={{ cursor: "pointer" }}
              to="about"
            >
              <span className="animated">
                <i className="fas fa-arrow-down" />
              </span>
            </Link>
          </div>
        </Parallax>
      </div>
    </section>
  );
};

export default FullScreenImgBgIntro;